'use strict';

import { Form } from '@lf/mwuikit/src/scripts/objects/form';

(function () {
    const formElement = document.getElementById('mini-scpi-simulator-form');

    if (formElement) {
        const form = Form({ element: formElement });

        const inputEvents = ['change', 'input'];
        const durationInputElement = formElement.querySelector('input[name=Duration]');
        const durationRangeElement = formElement.querySelector('input[name=DurationRange]');
        const investmentInputElement = formElement.querySelector('input[name=Investment]');
        investmentInputElement.type = "text";
        investmentInputElement.value = investmentInputElement.value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        const investmentRangeElement = formElement.querySelector('input[name=InvestmentRange]');

        let investment = !!investmentInputElement ? investmentInputElement.value : 0;
        let duration = !!durationInputElement ? durationInputElement.value : 0;

        const dvmDataArray = JSON.parse(formElement.dataset.dvmValues);
        const moniwanOfferRate = formElement.dataset.moniwanOfferRate;

        const advantageAmountBinding = formElement.querySelector('[data-binding="advantage-amount"]');
        const totalIncomeAmountBinding = formElement.querySelector('[data-binding="total-income-amount"]');
        const durationBinding = formElement.querySelector('[data-binding="duration"]');

        function calculateIncome(investment, duration) {
            let totalIncomeAmount = 0;
            let firstYearIncomeAmount = 0;

            let counter = 0;
            let yearCounter = new Date().getFullYear();
            let advantageAmount = investment * moniwanOfferRate;

            while (counter < duration) {
                const dvmData = dvmDataArray.filter(dvm => dvm.Year === yearCounter)[0];

                if (dvmData) {
                    counter++;
                    totalIncomeAmount += dvmData.Value / 100 * investment;

                    if (counter == duration) {
                        firstYearIncomeAmount = dvmData.Value / 100 * investment;
                    }
                }

                yearCounter--;
            }

            advantageAmountBinding.innerHTML = advantageAmount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 });
            totalIncomeAmountBinding.innerHTML = totalIncomeAmount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 });
            durationBinding.innerHTML = duration + (duration <= 1 ? '&nbsp;an' : '&nbsp;ans');
        }

        if (!!durationInputElement) {
            for (let i = 0; i < inputEvents.length; i++) {
                durationInputElement.addEventListener(inputEvents[i], function () {
                    let newDuration = this.value;

                    if (!!durationRangeElement) durationRangeElement.value = newDuration;

                    if (newDuration !== duration) {
                        duration = newDuration;
                        calculateIncome(investment.toString().replace(/[\s\D]+/g, ''), duration);
                    }
                });
            }
        }

        if (!!durationRangeElement) {
            durationRangeElement.addEventListener('change', function () {
                const newDuration = parseFloat(this.value);

                if (!!durationInputElement) durationInputElement.value = newDuration;

                if (newDuration !== duration) {
                    duration = newDuration;
                    calculateIncome(investment.toString().replace(/[\s\D]+/g, ''), duration);
                }
            });
        }

        if (!!investmentInputElement) {
            for (let i = 0; i < inputEvents.length; i++) {
                investmentInputElement.addEventListener(inputEvents[i], function () {
                    // Remove existing spaces and non-digit characters
                    let newInvestment = this.value.replace(/[\s\D]+/g, '');
                    // Add space as thousands separator
                    const formattedValue = newInvestment.replace(/\B(?=(\d{3})+(?!\d))/g, ' ').split('').join('');

                    if (!!investmentRangeElement) investmentRangeElement.value = newInvestment;

                    if (newInvestment !== investment) {
                        investment = newInvestment;
                        calculateIncome(investment, duration);
                    }
                    this.value = formattedValue;
                });
            }
        }

        if (!!investmentRangeElement) {
            investmentRangeElement.addEventListener('change', function () {
                const newInvestment = parseFloat(this.value);
                const formattedValue = this.value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                if (!!investmentInputElement) investmentInputElement.value = formattedValue;

                if (newInvestment !== investment) {
                    investment = newInvestment;
                    calculateIncome(investment, duration);
                }
            });
        }
    }
}());
